<div class="cb-margin"
     *cbWaitFor="cacheLoaded$ | async">
    <mat-card class="cb-margin-bottom flex-col">
        <mat-card-content>
            <form #form="ngForm">
                <div class="start-center flex-row flex">
                    <mat-icon>search</mat-icon>
                    <cb-input type="text"
                              label="Search"
                              [ngModel]="searchFiltersCache.data.query"
                              (ngModelChange)="queryChanged($event)"
                              name="search"
                              class="cb-margin-left cb-margin-right-2x flex">
                    </cb-input>
                    @if (designTeamPermissions.canSeeAll()) {
                        <cb-select label="Assigned To"
                                   name="userId"
                                   [(ngModel)]="searchFiltersCache.data.userId"
                                   [options]="teamUsersOptions$ | async"
                                   class="cb-margin-right-2x">
                        </cb-select>
                    }
                    <cb-select-list label="Status"
                                    name="statusId"
                                    class="cb-margin-right-2x flex"
                                    [allOptions]="schemeStatuses$ | async"
                                    [multiple]="true"
                                    [(value)]="searchFiltersCache.data.statusId">
                    </cb-select-list>
                    <cb-select label="Order"
                               name="resultOrders"
                               [(ngModel)]="searchFiltersCache.data.order"
                               [options]="resultOrders$ | async"
                               class="cb-margin-right-2x">
                    </cb-select>
                    <cb-select class="cb-margin-right"
                               label="Direction"
                               [(ngModel)]="searchFiltersCache.data.direction"
                               name="direction"
                               [options]="resultDirections$ | async">
                    </cb-select>
                    <span class="flex"></span>
                    <cb-button class="cb-margin"
                               (clicked)="openDesignTeamWorkLoadDialog()">
                        Workload
                    </cb-button>
                </div>
            </form>
            <cb-table class="cb-margin-top flex"
                      label="Design Schemes"
                      maxHeightOffset="280"
                      [infiniteScrollEnabled]="infiniteScrollEnabled"
                      [fetch]="fetchResults()"
                      [loaded]="loaded"
                      [(fetchInProgress)]="fetchInProgress"
                      [queryUpdated]="searchFiltersChanged$"
                      [(results)]="results"
                      [(currentPage)]="currentPage">
                <thead cbTableHead>
                <tr>
                    <td>Job #</td>
                    <td>Lot #</td>
                    <td>Project</td>
                    <td>Address</td>
                    <td>Client Account Name</td>
                    <td>Revision</td>
                    <td>Complexity</td>
                    <td>Created</td>
                    <td>Last Finalised</td>
                    <td>Due</td>
                    <td>Status</td>
                    <td>Assigned To</td>
                    <td></td>
                </tr>
                </thead>
                <tbody cbTableBody>
                    @for (scheme of results; track scheme) {
                        <tr>
                            <cb-td-text [value]="scheme.jobNumber"></cb-td-text>
                            <cb-td-text [value]="scheme.lotNumber"></cb-td-text>
                            <cb-td-text [value]="scheme.projectName"></cb-td-text>
                            <cb-td-text [value]="getStreetAddress(scheme)"></cb-td-text>
                            <cb-td-text [value]="scheme.clientAccountName"></cb-td-text>
                            <cb-td-text [value]="scheme.revisionNumber"></cb-td-text>
                            <cb-td-text [value]="scheme.complexityCode"></cb-td-text>
                            <cb-td-date [value]="scheme.createdDate"></cb-td-date>
                            <cb-td-date [value]="scheme.finalisedDate"></cb-td-date>
                            <cb-td-date [value]="scheme.dueBy"></cb-td-date>
                            <cb-td-text [value]="scheme.status"></cb-td-text>
                            <cb-td-text [value]="scheme.assignedToUserName"></cb-td-text>
                            <td cbTableShrinkCol
                                cbTableStickyCol="end">
                                <cb-button [menu]="menu"></cb-button>
                                <mat-menu #menu="matMenu">
                                    @if (hasPermissionsToEdit$ | async) {
                                        <cb-button
                                            icon="edit"
                                            menuItemLabel="Edit Scheme"
                                            [isMenuItem]="true"
                                            [disabled]="!(canEdit$(scheme) | async)"
                                            (clicked)="editScheme(scheme)">
                                        </cb-button>
                                    }
                                    <cb-button icon="pageview"
                                               menuItemLabel="View Lot"
                                               [isMenuItem]="true"
                                               (clicked)="viewLot(scheme.lotId)">
                                    </cb-button>
                                </mat-menu>
                            </td>
                        </tr>
                    }
                </tbody>
            </cb-table>
        </mat-card-content>
    </mat-card>
</div>
